import React, { useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { PlayerContext } from "../../backend/PlayerContext";
import { EquipmentSetButtons } from "../inventory/EquipmentSetButtons";
import { AutocastLoadoutLoadContainer } from "../utility/AutocastLoadoutLoadContainer";
import CategoryContainer from "../utility/CategoryContainer";
import { Text } from "../utility/Text";

export function LoadoutsContainer() {
  const playerContext = React.useContext(PlayerContext);

  const lastLoadoutUsed =
    playerContext.global.autocastLoadouts?.[
      playerContext.autocast.lastLoadoutUsed
    ]?.name ?? null;

  return useMemo(
    () => (
      <View style={styles.mainContainer}>
        <View style={styles.actionsContainer}>
          <CategoryContainer
            title="Equipment Sets"
            containerStyle={styles.equipmentContainer}
          >
            <View style={styles.categoryContents}>
              <EquipmentSetButtons />
            </View>
          </CategoryContainer>
          <CategoryContainer
            title="Apprentice Loadouts"
            containerStyle={styles.autocastContainer}
          >
            <View style={styles.categoryContents}>
              <AutocastLoadoutLoadContainer />
              {lastLoadoutUsed != null && (
                <View style={styles.lastLoadedContainer}>
                  <Text>Last loaded: {lastLoadoutUsed}</Text>
                </View>
              )}
            </View>
          </CategoryContainer>
        </View>
      </View>
    ),
    [lastLoadoutUsed],
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    height: "100%",
  },
  actionsContainer: {
    flex: 1.5,
    marginRight: 8,
  },
  equipmentContainer: {
    paddingTop: 0,
    marginBottom: 8,
  },
  autocastContainer: {
    paddingTop: 0,
  },
  categoryContents: {
    marginTop: 8,
  },
  lastLoadedContainer: {
    marginTop: 8,
  },
});
